import React, { useState } from 'react'
import RestaurantPage from "../../Pages/RestaurantDetails/index"
import { useNavigate } from 'react-router-dom'
const Index = ({data}) => {
   const [search,Setsearch]=useState("");
  
    // console.log(data)
    const navigate=useNavigate();
    const filteredData = data.filter((el) => {
    if (search.trim() === "") {
      return true; 
    }
    return (
      el.name?.toLowerCase().includes(search.toLowerCase()) || 
      el.number?.toString().includes(search) ||
      el.email?.toLowerCase().includes(search.toLowerCase())
    );
  });
    const handlechange=(e)=>{
        const value=e.target.value;
        Setsearch(value);
        console.log(value)
    }
   return (
    <div className="w-full flex-1 flex flex-col min-h-0 mt-4">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-2 flex-shrink-0 gap-2 md:gap-0">
        <h2 className="text-lg md:text-xl font-bold text-gray-800">Week Meal Not Added</h2>
        <input 
          className="flex-shrink-0 w-full md:w-1/3 border-2 px-4 py-2 rounded-lg outline-none focus:border-blue-500" 
          placeholder="Search number..." 
          onChange={handlechange}  
          value={search}
        />
      </div>

      <div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className="min-w-max w-full bg-white shadow-md border-collapse">
          <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
            <tr>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Restaurant Id</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Restaurant Name</th>
            </tr>
          </thead>
          <tbody>
        {filteredData.map((restaurant,index)=>(
          <tr 
            key={index} 
            className="border-b border-gray-300 hover:bg-gray-50 transition hover:text-blue-900 cursor-pointer"
            onClick={()=>navigate(`/restaurant/${restaurant.id}`)}
          >
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">{restaurant.id}</td>
            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800 font-medium">{restaurant.name}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>
   )
}

export default Index
